<template>
  <v-dialog v-model="showPopup" persistent max-width="520">
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Are you sure you want to leave this page without saving your changes?
      </v-card-title>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('doCancel')"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="$emit('doExit')"
          depressed
          class="save-btn small-size"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showPopup: {
      type: Boolean,
      required: true,
      default: false
    }
  }
}
</script>
